<template lang="html">
  <section class="app-read-mail" role="tablist">
    <b-card no-body class="mb-1" :key="idx" v-for="(mail, idx) in mails">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="" v-b-toggle="'accordion-'+idx" variant="light">{{mail.recipient_email}} | {{mail.subject}}</b-button>
      </b-card-header>
      <b-collapse :id="'accordion-'+idx" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text class="d-flex">
<!--            <img :src="encodeURI(getBaseURL + mail.src)" :alt="mail.name" class="img-fluid img-thumbnail w-25">-->
            <div class="d-flex flex-wrap justify-content-between">
              <div><strong>mail_id : </strong>{{mail.mail_id}}</div>
              <div><strong>smtp_host : </strong>{{mail.smtp_host}}</div>
              <div><strong>smtp_auth : </strong>{{mail.smtp_auth}}</div>
              <div><strong>smtp_username : </strong>{{mail.smtp_username}}</div>
              <div><strong>smtp_password : </strong>{{mail.smtp_password}}</div>
              <div><strong>smtp_secure : </strong>{{mail.smtp_secure}}</div>
              <div><strong>smtp_port : </strong>{{mail.smtp_port}}</div>
              <div><strong>set_from_email : </strong>{{mail.set_from_email}}</div>
              <div><strong>set_from_name : </strong>{{mail.set_from_name}}</div>
              <div><strong>recipient_email : </strong>{{mail.recipient_email}}</div>
              <div><strong>recipient_name : </strong>{{mail.recipient_name}}</div>
              <div><strong>reply_to_email : </strong>{{mail.reply_to_email}}</div>
              <div><strong>reply_to_name : </strong>{{mail.reply_to_name}}</div>
              <div><strong>cc_email : </strong>{{mail.cc_email}}</div>
              <div><strong>cc_name : </strong>{{mail.cc_name}}</div>
              <div><strong>bcc_email : </strong>{{mail.bcc_email}}</div>
              <div><strong>bcc_name : </strong>{{mail.bcc_name}}</div>
              <div><strong>attachments : </strong>{{mail.attachments}}</div>
              <div><strong>is_html : </strong>{{mail.is_html}}</div>
              <div><strong>subject : </strong>{{mail.subject}}</div>
              <div><strong>body : </strong>{{mail.body}}</div>
              <div><strong>alt_body : </strong>{{mail.alt_body}}</div>
              <div><strong>date_created : </strong>{{mail.date_created}}</div>
            </div>
          </b-card-text>
          <b-card-text class="mt-4 text-center">
            <button type="button" class="btn btn-danger ml-3"
                    @click="navigateAway({id: mail.mail_id, title: mail.subject}, 'delete')">
              Delete
            </button>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from "vuex";
export default {
  name: 'ReadAward',
  props: [],
  mounted () {},
  created () {
    this.readData()
      .then(data => this.mails = data)
      .catch()
  },
  data () {
    return {
      mails: null,
    }
  },
  methods: {
    ...mapActions([
      'setCurrentElement',
      'setOperation',
      'setCrudComponent',
      'setPreviousOperation',
      'readData'
    ]),
    navigateAway(object, tab) {
      this.setCurrentElement(object);
      this.setPreviousOperation(this.getOperation);
      this.setOperation(tab);
      this.setCrudComponent('app-' + tab + '-' + this.getComponent);
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentElement',
      'getOperation',
      'getComponent',
      'getBaseURL'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-read-mail {}
  .bgTextColor{
    background-color: var(--dark-color);
    color: var(--white-color);
  }
</style>



// WEBPACK FOOTER //
// src/components/mails/ReadMail.vue